module.exports = __webpack_public_path__ + "19ed8397f3b06c26df8baa6c0e692bd0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/headphones.png
// module id = 2767
// module chunks = 0